import React, { Component } from 'react';
import Deltaker from "./Deltaker";
import {
    Link
} from 'react-router-dom';

import {ResultService} from "../../services/resultService";

class Deltakerliste extends Component {

    constructor(props) {
        super(props);

        this.state = {
            isMounted: false,
            hovedparti: null,
            deltakere: [],
            deltakereKatalognrRekkefoelge: true,
            dommerNavn: null,
            klasse: null,
            caciobPaaProeve: null,
            delPartiCheckedIn: null,
            delPartiCheckedOut: null,
            underKlassePartier:[]
        }
        this._isMounted = false;
        this.renderDeltakerListe = this.renderDeltakerListe.bind(this);
        this.renderKlasseHeader = this.renderKlasseHeader.bind(this);
        this.renderUnderKlassePartiHeader = this.renderUnderKlassePartiHeader.bind(this);
        this.renderHovedKlassePartiHeader = this.renderHovedKlassePartiHeader.bind(this);
        this.renderFooter = this.renderFooter.bind(this);
        this.loadData = this.loadData.bind(this);
        this.caciobOppdatert = this.caciobOppdatert.bind(this);
        this.ikkeMoedtOppdatert = this.ikkeMoedtOppdatert.bind(this);
        this.getCaciobKatalogNr = this.getCaciobKatalogNr.bind(this);
        this.checkInDelKlasseParti = this.checkInDelKlasseParti.bind(this);
        this.checkOutUnderKlasseParti = this.checkOutUnderKlasseParti.bind(this);
        this.updateUnderKlassePartier = this.updateUnderKlassePartier.bind(this);
        this.sorterDeltakere = this.sorterDeltakere.bind(this);
    }

    componentDidMount() {
        if (this.props.partiLoaded) {
            this.loadData();
        }
       this._isMounted = true;
    }

    componentWillReceiveProps(nextProps) {
        if (!this.props.partiLoaded && nextProps.partiLoaded) {
            this.loadData();
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
    }



    renderFooter() {
        return (
            <nav className="navbar navbar-default navbar-fixed-bottom" >
                <div className="container">
                    <Link to="/sync">
                        <button className="btn btn-primary navbar-btn">Ring administration</button>
                    </Link>
                </div>
            </nav>
        );

    }

    renderUnderKlassePartiHeader() {
        const {hovedparti, klasse, delPartiCheckedIn} = this.state;

        if (hovedparti == null || hovedparti) { return null; }
        return (
            <div className="bs-callout bs-callout-warning">
                <h4>Klassens øvelser er delt på flere hold</h4>
                <p>I dette hold bedæmmes kun øvlser {klasse.fraOevelse} - {klasse.tilOevelse}. Så snart øvelsene i dette hold er bedømt færdig
                skal der klikkes på "Afslut bedømmelser". Når bedømmelser er afsluttet i dette hold blive eventuelle resterende bedømmelser foretaget i
                klassens hovedhold</p>
                <p>
                    {
                        delPartiCheckedIn === null &&
                            <button className="btn btn-default" onClick={() => this.checkInDelKlasseParti()}>Afslut bedømmelser</button>
                    }
                    {
                        delPartiCheckedIn !== null &&
                            <button disabled={true} className="btn btn-default">Afsluttet</button>
                    }

                </p>
            </div>
        );
    }

    renderHovedKlassePartiHeader() {

        const {underKlassePartier} = this.state;
        if( underKlassePartier.length === 0 ) {
            return null;
        }
        return (
            <div className="bs-callout bs-callout-warning">
                <h4>Klassens øvelser er delt på flere hold</h4>
                <p>
                    Dette er klassens hovedhold.
                    Efterhånden som bedømmelserne er færdige i den/de andre hold,  skal disse resultater hentes til dette hold. Hent bedømmelserne ved at klikke på "Hent bedømmelser" nedenfor.
                </p>
                <table className="table">
                <thead>
                <tr>
                    <th>Dommer til holdet</th>
                    <th>Øvelser</th>
                    <th width="200">
                        Bedømmelserne er færdige<br/>
                        i klassens anden hold
                    </th>
                    <th width="200">Bedømmelser hentet</th>
                </tr>
                </thead>
                <tbody>
                {
                    underKlassePartier.map(underKlasseParti =>
                        <tr key={underKlasseParti.partiId}>
                            <td>{underKlasseParti.dommerNavn}</td>
                            <td>{underKlasseParti.fraOevelse} - {underKlasseParti.tilOevelse}</td>
                            <td>
                                {
                                    underKlasseParti.checkedIn !== null &&
                                    <span className="status-ok">Ja</span>
                                }

                                {
                                    underKlasseParti.checkedIn === null &&
                                    <span className="status-not-ok">Nej</span>
                                }

                            </td>
                            <td className="center">
                                {
                                    underKlasseParti.checkedIn !== null && underKlasseParti.checkedOut === null &&
                                        <button className="btn btn-default" onClick={() => this.checkOutUnderKlasseParti(underKlasseParti.partiId)}> Hent bedømmelser</button>
                                }
                                {
                                    underKlasseParti.checkedOut !== null &&
                                    <span className="status-ok">Ja</span>
                                }
                            </td>
                        </tr>
                    )
                }
                </tbody>
                </table>
            </div>
        );
    }

    renderKlasseHeader() {

        const {klasse, dommerNavn} = this.state;
        if (klasse === null) return null;
        return (
            <div>
                { this.renderHovedKlassePartiHeader() }
                { this.renderUnderKlassePartiHeader() }

                <h3>{klasse.klasseNavn}</h3>
                <h4>
                    {
                        klasse.deltPaaOevelser &&
                        <span>Øvelser: {klasse.fraOevelse} - {klasse.tilOevelse}</span>
                    }
                </h4>
                <h4>
                    Dommer: {dommerNavn}

                </h4>
            </div>
        );

    }

    renderDeltakerListe() {
        const {partiLoaded} = this.props;
        if (!partiLoaded) {
            return null;
        }

        const {deltakere, caciobPaaProeve, delPartiCheckedIn, hovedparti, deltakereKatalognrRekkefoelge} = this.state;
        let sorterText = "Sorter efter katalognr";
        if (deltakereKatalognrRekkefoelge) {
            sorterText = "Sorter efter placering"
        }

        const caciobKatalogNr = this.getCaciobKatalogNr(deltakere, "CACIOB");
        const reserveCaciobKatalogNr = this.getCaciobKatalogNr(deltakere, "RCACIOB");
        return (
            <div className="row">
                <div className="col-sm-12">
                    { this.renderKlasseHeader() }
                    <div className="boxed">
                        <table className="table table-klasse">
                            <tbody>
                            <tr>
                                <th>
                                    <button className="navbar-btn" onClick={this.sorterDeltakere}>
                                        {sorterText}
                                    </button>
                                </th>
                                <th align="center">
                                    <span className="hidden-xs">Placering</span>
                                    <span className="visible-xs">Plac.</span>
                                </th>
                                <th align="center">
                                    <span className="hidden-xs">Point</span>
                                    <span className="visible-xs">Point</span>
                                </th>
                                <th align="center">
                                    <span className="hidden-xs">Præmie</span>
                                    <span className="visible-xs">Præmie</span>
                                </th>
                                {
                                    caciobPaaProeve &&
                                    <th align="center">
                                        <span className="hidden-xs">Caciob</span>
                                        <span className="visible-xs">Caciob</span>
                                    </th>
                                }

                                {
                                    caciobPaaProeve &&
                                    <th align="center">
                                        <span className="hidden-xs">Res.<br/>Caciob</span>
                                        <span className="visible-xs">R.<br/>Caciob</span>
                                    </th>
                                }

                                <th align="center">
                                    <span className="visible-xs">IM</span>
                                    <span className="hidden-xs">Ikke mødt</span>
                                </th>
                                <th align="center"></th>
                            </tr>
                            {
                                deltakere.map(deltaker => <Deltaker key={deltaker.hund.katalogNr}
                                                                    caciobPaaProeve={caciobPaaProeve}
                                                                    hovedparti={hovedparti}
                                                                    delPartiCheckedIn={delPartiCheckedIn}
                                                                    caciobOppdatert={this.caciobOppdatert}
                                                                    ikkeMoedtOppdatert={this.ikkeMoedtOppdatert}
                                                                    caciobKatalogNr={caciobKatalogNr}
                                                                    reserveCaciobKatalogNr={reserveCaciobKatalogNr}
                                                                    deltaker={deltaker} />)
                            }

                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    };


    render() {
        const {partiLoaded} = this.props;
        return (
            <div>

                <div className="container">

                    <br/>
                    {
                        !partiLoaded && (
                            <div className="row boxed">
                                <div className="col-sm-12">
                                    <h4>Ingen ring er valgt!</h4>
                                </div>
                            </div>
                        )
                    }
                    {this.renderDeltakerListe()}

                </div>

                {this.renderFooter()}

            </div>
        );
    }

    loadData() {
        this.updateUnderKlassePartier();
        this.setState(() => ({
            deltakere : ResultService.getDeltakerListe(this.state.deltakereKatalognrRekkefoelge),
            klasse: ResultService.getKlasse(),
            dommerNavn: ResultService.getDommerNavn(),
            caciobPaaProeve: ResultService.isCaciobPaaProeve(),
            hovedparti: ResultService.isHovedparti(),
            delPartiCheckedIn: ResultService.getDelPartiCheckedIn(),
            delPartiCheckedOut: ResultService.getDelPartiCheckedOut(),
        }));



    }

    ikkeMoedtOppdatert(katanr, ikkeMoedt) {
        let perform = false;
        if (ikkeMoedt && ResultService.isPoengOgKommentarerRegistrert(katanr)) {
            if (window.confirm("Skal point og kommentarer slettes?")) perform = true;
        } else {
            perform = true;
        }
        if (perform) {
            ResultService.setIkkeMoedt(katanr, ikkeMoedt);
            this.setState(() => ({
                deltakere : ResultService.getDeltakerListe(this.state.deltakereKatalognrRekkefoelge),
            }));
        }
    }

    caciobOppdatert(katanr, caciob) {
        ResultService.oppdaterCaciob(katanr, caciob);
        this.setState(() => ({
            deltakere : ResultService.getDeltakerListe(this.state.deltakereKatalognrRekkefoelge),
        }));
    }

    getCaciobKatalogNr(deltakere, caciob) {
        for (var i = 0; i < deltakere.length; i++) {
            if (deltakere[i].hund.resultat.caciob === caciob) {
                return deltakere[i].hund.katalogNr;
            }
            if (deltakere[i].hund.resultat.caciob === caciob) {
                return deltakere[i].hund.katalogNr;
            }
        }
        return null;
    }

    updateUnderKlassePartier(updatePlasseringer) {
        if (ResultService.isUnderklasserPartierCheckedOut())  {
            this.setState(() => ({
                underKlassePartier: ResultService.getUnderKlassePartier().slice()
            }));
        } else {
            ResultService.updateUnderKlassePartier()
                .then(()=>{
                    if (this._isMounted) {
                        this.setState(() => ({
                            underKlassePartier: ResultService.getUnderKlassePartier().slice()
                        }));
                    }
                })
                .catch((err)=> {
                    console.log(err);
                });
        }

    }

    checkInDelKlasseParti() {
        ResultService.checkInDelKlasseParti()
            .then(()=>{
                this.loadData();
            })
            .catch((err)=> {
                alert(err);
            });

    }

    checkOutUnderKlasseParti(underKlassePartiId) {
        ResultService.checkOutUnderKlasseParti(underKlassePartiId)
            .then(()=>{
                ResultService.updateUnderKlassePartier()
                    .then(()=>{
                        ResultService.updatePlasseringer();
                        this.setState(() => ({
                            deltakere : ResultService.getDeltakerListe(this.state.deltakereKatalognrRekkefoelge),
                            underKlassePartier: ResultService.getUnderKlassePartier().slice()
                        }));
                    })
            })
            .catch((err)=> {
                alert(err);
            });


    }

    sorterDeltakere() {
        this.setState(() => ({
            deltakere : ResultService.getDeltakerListe(!this.state.deltakereKatalognrRekkefoelge),
            deltakereKatalognrRekkefoelge: !this.state.deltakereKatalognrRekkefoelge
        }));

    }
}





export default Deltakerliste;





// WEBPACK FOOTER //
// ./src/pages/deltakerliste/Deltakerliste.js